import { render, staticRenderFns } from "./TermsAndConds.vue?vue&type=template&id=7ef15a97&scoped=true&"
import script from "./TermsAndConds.vue?vue&type=script&lang=js&"
export * from "./TermsAndConds.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConds.vue?vue&type=style&index=0&id=7ef15a97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef15a97",
  null
  
)

export default component.exports